import { Button } from "@/components/ui/Button";

import { useWebsocketContext } from "@/lib/WebsocketProvider";
import { useNavigate } from "react-router";
// @ts-expect-error figure this out later
import xkcdComic from "../images/xkcd-3179.png";

export function RootRoute() {
  const navigate = useNavigate();

  const websocket = useWebsocketContext();

  return (
    <div className="flex flex-col min-h-screen">
      <main className="mx-auto flex flex-col items-center justify-end max-w-md px-6 pt-6 md:pt-16 lg:pt-24">
        <img
          className="w-full"
          src={xkcdComic}
          title="The draw-by-repetition rule does a good job of keeping players from sliding a tile back and forth repeatedly, but the tiles definitely introduce some weird en passant and castling edge cases."
        />
        <div className="text-center mt-4">
          <h1 className="font-handwriting text-4xl">chesskcd</h1>
          <p className="text-lg">aka "Sliding Number Puzzle Chess"</p>
        </div>
      </main>
      <div className="flex-1 max-w-md mx-auto text-center space-x-2 pt-2">
        <Button>Rules</Button>
        <Button
          onClick={async () => {
            websocket?.emit("ROOM_CREATE", {}, (response: { id: string }) => {
              navigate(`/room/${response.id}`);
            });
          }}>
          Create Room
        </Button>
        <div className="mt-8 p-4 border border-dashed font-handwriting mx-4">
          notice: this is sliding chess but it is incredibly buggy. proceed with caution (and/or have fun)!
        </div>
      </div>

      <footer className="max-w-4xl mx-auto px-6 pb-6 md:pb-8 lg:pb-12 mt-6">
        <strong>Credit and thanks to:</strong>
        <ul className="list-disc pl-4">
          <li>
            <a className="underline" href="https://xkcd.com/about/">
              Randall Munroe
            </a>{" "}
            for{" "}
            <a className="underline" href="https://xkcd.com/3139/">
              xkcd Comic #3139
            </a>{" "}
            under the{" "}
            <a
              className="underline"
              href="https://creativecommons.org/licenses/by-nc/2.5/">
              Creative Commons Attribution-NonCommercial 2.5 License
            </a>
          </li>
          <li>
            <a className="underline" href="https://github.com/ipython">
              ipython
            </a>{" "}
            for the{" "}
            <a
              className="underline"
              href="https://github.com/ipython/xkcd-font/tree/master">
              xkcd Script
            </a>{" "}
            font under the{" "}
            <a
              className="underline"
              href="https://github.com/ipython/xkcd-font/blob/master/LICENSE">
              Creative Commons Attribution-NonCommercial 3.0 License
            </a>
          </li>
          <li>
            u/anarchy-NOW for the{" "}
            <a
              className="underline"
              href="https://www.reddit.com/r/AnarchyChess/comments/1nc91ok/comment/nd7z43v">
              name idea
            </a>
          </li>
        </ul>
      </footer>
    </div>
  );
}
